
/**
 * Replaces .not-teacher with .is-teacher for all .js-teacher-status elements.
 *
 * This unsticks the mobile give box so it isn't always at the bottom of the screen.
 */
export const markTeacherViewingSelf = () => {
	const teacherStatusDivs = document.getElementsByClassName("js-teacher-status");

	for (let i = 0; i < teacherStatusDivs.length; i++) {
		// I've added the redundant `js-` classes at Tea's request
		// (to make it clear that Product shouldn't remove/rename them).
		teacherStatusDivs[i].classList.remove("not-teacher");
		teacherStatusDivs[i].classList.remove("js-the-teacher");
		teacherStatusDivs[i].classList.add("is-teacher");
		teacherStatusDivs[i].classList.add("js-is-teacher");
	}
};
